import { render, staticRenderFns } from "./CustomerNew.vue?vue&type=template&id=60125a8a&scoped=true&"
import script from "./CustomerNew.vue?vue&type=script&lang=js&"
export * from "./CustomerNew.vue?vue&type=script&lang=js&"
import style0 from "./CustomerNew.vue?vue&type=style&index=0&id=60125a8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60125a8a",
  null
  
)

export default component.exports